import { CampaignContext } from 'pages/Campaign/CampaignContext/CampaignContext';
import { ReactNode, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router';

export interface ExtendedIntlShapeUI {
  formatCampaignURLValidationMsg: () => ReactNode;
}

export function useExtendedIntlForUI(): ExtendedIntlShapeUI {
  const { formatMessage: baseFormatMessage } = useIntl();
  const { campaignPrettyId, campaignURL } = useContext(CampaignContext);

  const formatCampaignURLValidationMsg = useCallback<ExtendedIntlShapeUI['formatCampaignURLValidationMsg']>(
    () =>
      baseFormatMessage(
        { id: 'campaign.url-domain.validation-message' },
        {
          campaignUrl: <b>{campaignURL}</b>,
          b: (parts: ReactNode[]) => <b>{parts}</b>,
          advancedOptionsLink: (parts: ReactNode[]) => (
            <Link
              target="_blank"
              rel="noopener"
              style={{ textDecoration: 'underline' }}
              to={`/campaign/${campaignPrettyId}/ads-and-keywords/advanced-options/campaign-url`}
            >
              {parts}
            </Link>
          ),
        },
      ) as ReactNode,
    [campaignPrettyId, baseFormatMessage, campaignURL],
  );

  return {
    formatCampaignURLValidationMsg,
  };
}
